import { ForwardRefIcon } from '@components/shared/icons/ForwardRefIcon';
import { faEllipsisVAlt } from '@fortawesome/pro-solid-svg-icons';
import { Box, IconButton } from '@mui/material';
import * as React from 'react';
import { ComponentProps, useState } from 'react';
import { MenuDropdown } from './MenuDropdown';

type SxProps = ComponentProps<typeof Box>['sx'];

type UserDropdownProps = {
  sx?: SxProps;
  handleHelpModal: () => void;
};

const UserDropdown = (props: UserDropdownProps) => {
  const iconButtonStyles = {
    display: { sm: 'flex' },
    fontSize: '1.3rem',
    ...props.sx,
  };

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <IconButton
        aria-label="search"
        sx={iconButtonStyles}
        onClick={handleClick}
        id="nav-menu-btn"
      >
        <ForwardRefIcon icon={faEllipsisVAlt} />
      </IconButton>
      <MenuDropdown
        sx={props.sx}
        anchorEl={anchorEl}
        onClose={handleClose}
        onHelpModalToggle={props.handleHelpModal}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      />
    </>
  );
};

export default UserDropdown;
